import { BoxProps, Box } from '@mui/material'
import { FormattedMessage } from 'react-intl'
import { CartoFontWeight, Typography, TypographyProps } from '@carto/meridian-ds/components'
import { ElementType, ReactNode } from 'react'

interface FormattedTextBoxProps extends Omit<BoxProps, 'content'> {
  id?: string
  content?: ReactNode
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  values?: Record<string, any>
  component?: ElementType // vs TypographyProps['component']
  variant?: TypographyProps['variant']
  align?: TypographyProps['align']
  weight?: CartoFontWeight
}

export function FormattedTextBox(props: FormattedTextBoxProps) {
  const { weight, id, values, content, variant, color, align, component = 'p', ...boxProps } = props
  return (
    <Box {...boxProps}>
      <Typography component={component} align={align} variant={variant} color={color} weight={weight}>
        <>
          {id && <FormattedMessage id={id} values={values} />}
          {content && content}
        </>
      </Typography>
    </Box>
  )
}
